export enum ExternalInvoicesSyncStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN PROGRESS',
  NotInitiated = 'NOT INITIATED',
  VatRateError = 'VAT RATE ERROR',
}
